import React, { useReducer, useState, useEffect } from 'react'
import { Tab, Menu, Button, Segment, Header, Dimmer, Dropdown } from 'semantic-ui-react'
import BlockTab from '../GroupReservation/BlocksTab'
import GeneralTab from '../GroupReservation/GeneralTab'
import FitTab from '../GroupReservation/FitTab'
import { GetReservationGroups, GetRoomTypes, SendGroupConfirmationToGuest, GetDefaultReservationValues, RenderTemplateToPdf , GetDocuments } from '../../api/services/pms'
import { onWarning, onSuccess, onError } from '../../components/shared/messages'
import _ from 'lodash'
import './style.css'
import moment from 'moment'
import GroupTotals from './groupTotals'
import { ReservationStatusesEnums } from '../../components/shared/statustypes'
import PropTypes from 'prop-types'
import qs from 'querystringify'
import { GetHotelParameters } from '../../api/services/organization'
import { useLoader } from '../../components/shared/utils'
import { GroupReservationContext, actions } from './context'
import { MenuActions, TemplateType, EntityType } from '../../components/shared/constants'
import { PermissionsActions, UserHasPermission } from '../../components/shared/permissionsActions';
import { GetDefaultTemplateBySpecification } from '../../api/services/shared'
import SendMailPopup from '../../components/SendMailPopup';
import { useTextResources } from '../../language'
import ExtraAddons from '../../components/ExtraAddonsPopup'
import UploadFile from '../UploadFilesPopup'



export const GroupReservationReducer = (state, action) => {
    switch (action.type) {
        case actions.update: {
            if (typeof (action.payload) !== 'undefined') {
                return { ...state, isDirty: action.payload }
            }
            return { ...state, isDirty: true }
        }
        case actions.initialize: {
            state.ReservationGroup = action.payload
            return { ...state }
        }
        case actions.registerTabSave: {
            state.tabSave[action.index] = action.callback
            return { ...state }
        }
        case actions.setDirty: {
            return { ...state, isDirty: action.payload }
        }
        case actions.setRoomTypes: {
            return { ...state, RoomTypes: action.payload }
        }
        case actions.setHotelParameters: {
            return { ...state, Hotel: action.payload }
        }
        case actions.setReservationDefaults: {
            // if (state.ReservationGroup?.ReservationGroupReservations?.length)
            // {
            //     const reservation = state.ReservationGroup.ReservationGroupReservations[0].Reservation
            //     const defaultReservation = action.payload.HotelDefaultReservationValuesViewModel
            //     state.ReservationGroup.ReservationGroupReservations[0].Reservation = {
            //         ...defaultReservation,
            //         ...reservation
            //     }                
            // }
            return { ...state }
        }
        default:
            return state;
    }
}

const GroupReservation = ({ HotelID }) => {
    const loader = useLoader()
    const hotelId = window.optima?.user?.CurrentHotel?.Id || HotelID;
    const CurrencyId = window.optima?.user?.CurrentHotel?.MainCurrencyId || 2;
    const currentDate = moment().startOf('day')
    const [showSendEmail, setShowSendEmail] = useState(false);
    const [primaryReservation, setPrimaryReservation] = useState()
    const [openExtraAddons, setOpenExtraAddons] = useState(false)
    const [openUploadFile, setOpenUploadFile] = useState(false)
    const text = useTextResources()
    const [reservationDocuments,setReservationDocuments] = useState(null)
    const [reservationDailyAddonsExist, setReservationDailyAddonsExist] = useState(false)

    const emptyMainBlock = [{
        IsBlock: true,
        IsPrimaryReservationInGroup: true,
        ParentReservation: null,
        Reservation: {
            Id: 0,
            HotelID: hotelId,
            StatusId: 1,
            Quantity: 1,
            Adults: 2,
            Children: 0,
            Infants: 0,
            TotalAmountProductCurrentBeforeTax: 0,
            TotalAmountProductCurrentAfterTax: 0,
            CheckInDate: currentDate.toDate(),
            CheckOutDate: currentDate.add(1, 'days').toDate(),
            AveragePricePerNightBeforeTax: 0,
            AveragePricePerNightAfterTax: 0,
            Eta: "15:00:00",
            Edt: "12:0:00",
            RenderFoliosImmediately: true,
            TotalAmount: 0,
            RestPayment: 0,
            CurrencyId: CurrencyId,
            IsBlockReservaton: true,
            ReservationPricingTypeID: 1
        }
    }];

    const initialGroup = {
        Id: 0,
        HotelID: hotelId,
        Name: "",
        Color: "",
        IsRerouteToMainReservation: false,
        ReservationGroupReservations: emptyMainBlock
    }


    const [active, setActive] = useState(1);
    const [state, dispatch] = useReducer(GroupReservationReducer, { ReservationGroup: initialGroup, tabSave: [], isDirty: false, RoomTypes: [], Hotel: {} });

    const [groupDisabled, setGroupDisabled] = useState(false)

    const findPrimaryReservation = () => {
        const primary = _.find(state.ReservationGroup.ReservationGroupReservations, reservation => reservation.IsPrimaryReservationInGroup)
        return primary
    }

    useEffect(() => {
        if (window.optima.commands) {
            window.optima.commands.subscribe(MenuActions.save, () => {
                Save();
            });
        }
    }, [])

    useEffect(() => {
        (async () => {
            const [roomTypes, hotelParams, resertvationDefaults]  = await Promise.all([
                GetRoomTypes({HotelID: hotelId}),
                GetHotelParameters({ ID: hotelId }),
                GetDefaultReservationValues({
                    HotelId: hotelId,
                    IncludeAllProductRestrictions: UserHasPermission(
                        PermissionsActions.SelectOnlyUnrestrictedProduct
                    ),
                })
            ])
            dispatch({ type: actions.setRoomTypes, payload: roomTypes })
            dispatch({ type: actions.setHotelParameters, payload: hotelParams.CurrentHotel.length?hotelParams.CurrentHotel[0]:{} })
            dispatch({ type: actions.setReservationDefaults, payload:  resertvationDefaults})

            const params = qs.parse(window.location.search)
            const groupID = Number(params.groupid || params.groupID || params.groupId);
            if (groupID) {
                loader(true);
                let specification = {
                    "IDs[0]": groupID,
                    // change it to CurrentHotel
                    HotelID: hotelId,
                    IncludeReservations: true,
                    IncludeReservationGroupReservations: true,
                    IncludeReservationDailyAccommodations: true,
                    IncludeReservationDailyAddons: true,
                    "PropertiesToClean[0]": "ReservationDailyAccommodations",
                    "PropertiesToClean[1]": "ReservationDailyAddons",
                    IncludeCanceled: true,
                    IncludeRoom: true
                }
                const reservationsGroupDB = await GetReservationGroups(specification)
                if (reservationsGroupDB.length) {
                    const first = reservationsGroupDB[0];
                    let reservations = first.ReservationGroupReservations;
                    if (reservations.length) {
                        _.remove(reservations, r => {
                            return r?.Reservation?.StatusId === ReservationStatusesEnums.Cancelled
                        })
                        let primaryReservationGroupExists = _.find(reservations, r => { return r.IsPrimaryReservationInGroup })
                        if (!primaryReservationGroupExists) {
                            onWarning({ "error": { "ErrorMessage": "The group is cancelled" } });
                            setGroupDisabled(true)
                            loader(false);
                            return
                        }
                        _.forEach(reservations, reservation => {
                            if (reservation.Reservation) {
                                const roomType = _.find(roomTypes, ['Id', reservation.Reservation.RoomTypeId])
                                reservation.Reservation.RoomType = roomType
                                reservation.Reservation.RoomTypeName = roomType.Name

                                if (reservation.IsBlock) {
                                    reservation.Reservation.IsBlockReservaton = true
                                }

                            }
                        })
                        setReservationDailyAddonsExist(primaryReservationGroupExists.Reservation.TotalAmountAddons > 0)
                        setPrimaryReservation(primaryReservationGroupExists.Reservation)
                        const document =  await GetDocuments({ entityTypeId: EntityType.Reservation, entityId: primaryReservationGroupExists?.ReservationID})                        
                        setReservationDocuments(document)

                        dispatch({ type: actions.setRoomTypes, payload: roomTypes })
                    } else {
                        first.ReservationGroupReservations = emptyMainBlock
                    }
                    dispatch({ type: actions.initialize, payload: first });

                }
                else {
                    onWarning({ "error": { "ErrorMessage": "Group reservation could not be found" } });
                    setGroupDisabled(true)
                }
                loader(false);
            }
        })()
    }, [])


    const Save = () => {
        (async () => {
            if (state.tabSave[active] && await state.tabSave[active]()) {
                dispatch({ type: actions.setDirty, payload: false });
            }
        })();
    }

    const onNextTab = () => {
        (async () => {
            if (state.tabSave[active] && await state.tabSave[active]()) {
                dispatch({ type: actions.setDirty, payload: false });
                setActive(prev => prev + 1);
            }
        })();
    }

    const onPrevTab = () => {
        dispatch({ type: actions.setDirty, payload: false });
        setActive(prev => prev - 1)
    }

    const onTabChange = (e, { activeIndex }) => {
        const primary = findPrimaryReservation()
        if (primary && primary.ReservationID && primary.ReservationID !== 0) {
            setActive(activeIndex)
        }
    }

    const getGroupName = () => {
        if (state.ReservationGroup && state.ReservationGroup.Name) {
            return state.ReservationGroup.Name;
        }
        else {
            return text("NewGroup");
        }
    };

    const SendGroupConfirmation = async () => {
        let primary = findPrimaryReservation()
        if(primary){
            loader(true);
            try {
                await SendGroupConfirmationToGuest (primary.Reservation)
                onSuccess("ConfirmationEmailSent");
            } catch (error) {
                onWarning({ "error": { "ErrorMessage": "Error sending email" } });
                loader(false);
            }
            loader(false);
        }
    }

    const openMainFolio = () => {
        let primary = findPrimaryReservation()
        if(primary){
            let webShell =  window.optima?.$optimaUrls?.Shell||"/";
            let folioUrl = `${webShell}Finance/Folio/Folio?ReservationId=${primary.Reservation.Id}`;
            window.open(folioUrl, '_blank');
        }
    }

    const openExtraAddonPopup = () => {
        if (primaryReservation == null) {
            const primary = findPrimaryReservation()
            setPrimaryReservation(primary.Reservation)
        }
        setOpenExtraAddons(true)
    }

    const openSendMailPopup = () => {
        if (primaryReservation == null) {
            const primary = findPrimaryReservation()
            setPrimaryReservation(primary.Reservation)
        }
        setShowSendEmail(true)
    }
    const openUploadFilePopup = () => {
        if (primaryReservation == null) {
            const primary = findPrimaryReservation()
            setPrimaryReservation(primary.Reservation)
        }
        setOpenUploadFile(true)
    }

    const disableSettings = () => {
        let primary = findPrimaryReservation()
        if(primary && primary.Reservation && primary.Reservation.Id) return false
        return true
    }

    const printReservation = async () => {
        const primary = _.find(state.ReservationGroup.ReservationGroupReservations, reservation => reservation.IsPrimaryReservationInGroup);
        try {
            const templates = await GetDefaultTemplateBySpecification({
                HotelId: primary.Reservation.HotelId,
                TemplateTypeId: TemplateType.GroupConfirmation,
            });
            let template =
                templates.find((x) => x.LanguageID === primary.Reservation.Guest.LanguageID) ||
                templates.find((x) => x.LanguageID === null);

            if (template) {
                const result = await RenderTemplateToPdf({
                    FileName: template
                        ? template.TypeName
                        : '' + ' - ' + primary.Reservation.Number,
                    IsPrintable: true,
                    TemplateID: template ? template.TemplateID : null,
                    Paramters: [
                        {
                            key: 'ReservationId',
                            value: primary.Reservation?.Id,
                        },
                        {
                            key: 'HotelID',
                            value: primary.Reservation?.HotelId,
                        },
                    ],
                });
                window.open(result.DmzUrlPathAccessibleByBrowser);
            } else {
                onWarning('No default template was found');
            }
        } catch (error) {
            onError(error);
        }
    };

    return (
            <GroupReservationContext.Provider value={{ state, dispatch }}>
                <Dimmer active={groupDisabled} inverted style={{ opacity: 0.5 }} />
                <Tab menu={{ secondary: true, pointing: true, className: 'mainmenu' }} activeIndex={active} className="group"
                    onTabChange={onTabChange}
                    panes={[
                        { menuItem: <Menu.Menu className="groupHeader" key="title"><Menu.Item header><Header size='large'>{getGroupName()}</Header></Menu.Item></Menu.Menu> },
                        { menuItem: text('GeneralDetails'), render: () => <Tab.Pane ><GeneralTab /></Tab.Pane>, key: "general" },
                    { menuItem: text('RoomBlocks'), render: () => <Tab.Pane><BlockTab setGroupDisabled={() => {setGroupDisabled(true)}}/></Tab.Pane>, key: "block" },
                        { menuItem: text('IndividualReservations'), render: () => <Tab.Pane><FitTab /></Tab.Pane>, key: "fit" },

                        {
                            menuItem: <Menu.Menu key="totals" position="right">
                                <Dropdown disabled={disableSettings()} item direction="left" icon={{ name: "ellipsis vertical", size: "huge", style: { fontSize: "2em" } }}>
                                    <Dropdown.Menu>
                                    <Dropdown.Item icon={{className: "icon download"}} text={text("DownloadConfirmation")} onClick={printReservation}/>
                                    <Dropdown.Item disabled={false}  icon={{className: "icon icon-envelope-8"}} text={text("SendConfirmation")} onClick={SendGroupConfirmation}/>
                                    <Dropdown.Item icon={{className: "icon-wallet2"}} text={text("MainFolio")} onClick={openMainFolio}/>
                                        <Dropdown.Item icon={{ className: "icon icon-envelope-8" }} text={text("SendEmail")} onClick={openSendMailPopup} />
                                        <Dropdown.Item icon={{ className: reservationDailyAddonsExist ? "icon icon-add-contact red" :  "icon icon-add-contact"}} text={text("Addons")} onClick={openExtraAddonPopup} />
                                        <Dropdown.Item icon={{ className: reservationDocuments?.length > 0 ? "icon attach red" : "icon attach" }} text={text("DocumentsUpload")} onClick={openUploadFilePopup} style={{ color: reservationDocuments?.length > 0 ? 'red' : ""}}/>
                                    </Dropdown.Menu>
                                </Dropdown>
                                <GroupTotals HotelID={hotelId} />
                            </Menu.Menu>
                        }
                    ]} />
                <SendMailPopup
                    reservation={primaryReservation}
                    open={showSendEmail}
                    onClose={() => setShowSendEmail(false)}
                />
                <ExtraAddons
                    open={openExtraAddons}
                    onClose={() => {setOpenExtraAddons(false);dispatch({ type: actions.update, payload: false })}}
                    reservation={primaryReservation}
                    reservationDailyAddonsExist={setReservationDailyAddonsExist}
                />
                <UploadFile
                    open={openUploadFile}
                    onClose={() => setOpenUploadFile(false)}
                    documentSpec={{entityTypeId: EntityType.Reservation, entityId: primaryReservation?.Id}}
                    documents={reservationDocuments}
                    setDocument={setReservationDocuments}
                />
                <Segment basic style={{ padding: '0.5em' }}>
                    <Button size="big" floated="left" disabled={active < 2 || active === 2 && state.isDirty} onClick={onPrevTab} >{text('Back')}</Button>
                    <Button size="big" primary positive={active === 3} floated="right" disabled={active === 2 && state.isDirty} onClick={onNextTab} >{active === 3 ? text("Save") : text("Next")}</Button>
                </Segment>
            </GroupReservationContext.Provider>           
    )
}

GroupReservation.propTypes = {
    HotelID: PropTypes.any
}
export default GroupReservation